import React from "react";
import { Chip, Tooltip } from "@mui/material";
import MilitaryTechIcon from "@mui/icons-material/MilitaryTech";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import DiamondIcon from "@mui/icons-material/Diamond";

// Beneficios por plan de suscripción (mismos nombres que en subscription.js).
// rank: usado para ordenar resultados de búsqueda (mayor = aparece primero).
// maxProjectBudget: tope de presupuesto de proyecto al que puede postularse un freelancer con ese plan.
export const TIER_CONFIG = {
  none: {
    rank: 0,
    maxProjectBudget: 0,
    badge: null,
  },
  "Básico": {
    rank: 1,
    maxProjectBudget: 300,
    badge: { label: "Plata", color: "#9e9e9e", Icon: MilitaryTechIcon },
  },
  "Profesional": {
    rank: 2,
    maxProjectBudget: 1500,
    badge: { label: "Oro", color: "#d4a017", Icon: WorkspacePremiumIcon },
  },
  "Premium": {
    rank: 3,
    maxProjectBudget: Infinity,
    badge: { label: "Platino", color: "#8e7cc3", Icon: DiamondIcon },
  },
};

export const getTierInfo = (subscription) => {
  if (subscription?.status !== "ACTIVE") return TIER_CONFIG.none;
  return TIER_CONFIG[subscription.planName] || TIER_CONFIG.none;
};

export const MembershipBadge = ({ subscription, size = "small" }) => {
  const tier = getTierInfo(subscription);
  if (!tier.badge) return null;
  const { label, color, Icon } = tier.badge;
  return (
    <Tooltip title={`Miembro ${label} de Skach`}>
      <Chip
        size={size}
        icon={<Icon sx={{ color: `${color} !important` }} />}
        label={label}
        sx={{
          borderColor: color,
          color,
          fontWeight: 600,
        }}
        variant="outlined"
      />
    </Tooltip>
  );
};
